import React from "react";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import IconButton from "@mui/material/IconButton";
import Autocomplete from "@mui/material/Autocomplete";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";

export default function CampanhaFiltrosClientes({
  expandedFiltroCliente,
  handleFiltroClienteAccordion,
  todosClientesAcordosFiltradosIncluidos,
  clientesAcordosFiltrados,
  clientesAcordosCampanha,
  atualizarClientesIncluidosCampanha,
  filtroClientesAcordos,
  setFiltroClientesAcordos,
  toggleClienteAcordoIncluido,
  gruposClientes,
  filtroGrupoClienteSelecionado,
  toggleFiltroCampanha,
  loadingFiltrosCampanha,
  filtrosCampanha,
  atualizarFiltrosCampanhaLote,
  segmentosClientes,
  filtroExiste,
  clienteInput,
  setClienteInput,
  carregarClientesCombo,
  clientesCombo,
  adicionarFiltroCampanha,
  filtrosPorCampo,
  removerFiltroCampanha,
}) {
  return (
    <MDBox
      mt={2}
      p={{ xs: 1.25, md: 2 }}
      sx={{
        border: "1px solid #e0e0e0",
        borderRadius: 2,
        maxWidth: "100%",
        overflowX: "hidden",
      }}
    >
      <MDTypography variant="h6" mb={1}>
        Filtros de clientes
      </MDTypography>

      <Accordion
        expanded={expandedFiltroCliente === "acordos"}
        onChange={handleFiltroClienteAccordion("acordos")}
        disableGutters
        sx={{
          backgroundColor: "#fff4f4",
          borderRadius: 2,
          mb: 1,
          "&:before": { display: "none" },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ fontSize: 18 }} />}
          sx={{
            minHeight: 32,
            px: 1.5,
            "& .MuiAccordionSummary-content": { margin: "4px 0" },
          }}
        >
          <MDTypography variant="button" sx={{ fontSize: 12 }}>
            Clientes excluídos por acordos/descontos
          </MDTypography>
        </AccordionSummary>

        <AccordionDetails sx={{ pt: 0, pb: 1.5, px: 1.5 }}>
          <MDTypography variant="caption" color="text" sx={{ display: "block", mb: 1 }}>
            Clientes com acordo por tipo ou desconto máximo negociado ficam excluídos por defeito.{" "}
            <strong>Assinale apenas</strong> os que devem ser <strong>incluídos</strong> nesta
            campanha.
          </MDTypography>

          <MDBox mb={1} display="flex" alignItems="center" gap={1}>
            <TextField
              size="small"
              value={filtroClientesAcordos}
              onChange={(e) => setFiltroClientesAcordos(e.target.value)}
              placeholder="Filtrar cliente, ref, NIF, acordo ou observações..."
              fullWidth
            />
          </MDBox>

          <MDBox sx={{ maxHeight: 320, overflow: "auto", borderRadius: 1 }}>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
              <thead>
                <tr>
                  <th
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 2,
                      background: "#fff",
                      textAlign: "left",
                      padding: "6px 8px",
                      color: "#7b809a",
                      width: 52,
                      borderBottom: "1px solid #eee",
                    }}
                  >
                    <Checkbox
                      size="small"
                      checked={todosClientesAcordosFiltradosIncluidos}
                      indeterminate={
                        clientesAcordosFiltrados.some((c) => Number(c.incluido || 0) === 1) &&
                        !todosClientesAcordosFiltradosIncluidos
                      }
                      disabled={clientesAcordosFiltrados.length === 0}
                      onChange={async () => {
                        const atuais = clientesAcordosCampanha
                          .filter((x) => Number(x.incluido || 0) === 1)
                          .map((x) => String(x.refcliente || ""));

                        const refsFiltrados = clientesAcordosFiltrados.map((x) =>
                          String(x.refcliente || "")
                        );

                        const novos = todosClientesAcordosFiltradosIncluidos
                          ? atuais.filter((ref) => !refsFiltrados.includes(ref))
                          : Array.from(new Set([...atuais, ...refsFiltrados]));

                        await atualizarClientesIncluidosCampanha(novos);
                      }}
                    />
                  </th>

                  <th
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 2,
                      background: "#fff",
                      textAlign: "left",
                      padding: "6px 8px",
                      color: "#7b809a",
                      borderBottom: "1px solid #eee",
                    }}
                  >
                    Estado
                  </th>

                  <th
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 2,
                      background: "#fff",
                      textAlign: "left",
                      padding: "6px 8px",
                      color: "#7b809a",
                      borderBottom: "1px solid #eee",
                    }}
                  >
                    Cliente
                  </th>
                </tr>
              </thead>

              <tbody>
                {clientesAcordosFiltrados.map((c) => {
                  const incluido = Number(c.incluido || 0) === 1;

                  return (
                    <tr
                      key={`${c.refcliente}-${c.id}`}
                      style={{
                        backgroundColor: incluido ? "#eefaf0" : "#fff4f4",
                        borderBottom: "1px solid #eee",
                      }}
                    >
                      <td style={{ padding: "6px 8px", verticalAlign: "top" }}>
                        <Checkbox
                          size="small"
                          checked={incluido}
                          onChange={() => toggleClienteAcordoIncluido(c.refcliente)}
                        />
                      </td>

                      <td style={{ padding: "8px 8px", verticalAlign: "top", color: "#344767" }}>
                        <strong>{incluido ? "✅ INCLUÍDO" : "🚫 EXCLUÍDO"}</strong>
                      </td>

                      <td style={{ padding: "8px 8px", verticalAlign: "top", color: "#344767" }}>
                        <strong>{c.cliente || c.refcliente}</strong>
                        <span style={{ color: "#9e9e9e" }}> ({c.refcliente})</span>
                        {c.nif && <span style={{ color: "#9e9e9e" }}> | NIF: {c.nif}</span>}
                      </td>
                    </tr>
                  );
                })}

                {clientesAcordosCampanha.length === 0 && (
                  <tr>
                    <td colSpan={3} style={{ padding: "8px", color: "#7b809a" }}>
                      Não existem acordos registados para este fabricante.
                    </td>
                  </tr>
                )}

                {clientesAcordosCampanha.length > 0 && clientesAcordosFiltrados.length === 0 && (
                  <tr>
                    <td colSpan={3} style={{ padding: "8px", color: "#7b809a" }}>
                      Não existem clientes para o filtro indicado.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </MDBox>
        </AccordionDetails>
      </Accordion>

      <Accordion
        expanded={expandedFiltroCliente === "grupos"}
        onChange={handleFiltroClienteAccordion("grupos")}
        disableGutters
        sx={{
          backgroundColor: "#fff7f0",
          borderRadius: 2,
          mb: 1,
          "&:before": { display: "none" },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ fontSize: 18 }} />}
          sx={{
            minHeight: 32,
            px: 1.5,
            "& .MuiAccordionSummary-content": { margin: "4px 0" },
          }}
        >
          <MDTypography variant="button" sx={{ fontSize: 12 }}>
            Grupos de clientes
          </MDTypography>
        </AccordionSummary>

        <AccordionDetails sx={{ pt: 0, pb: 1.5, px: 1.5 }}>
          <MDBox display="flex" flexWrap="wrap" gap={1}>
            {gruposClientes.map((g) => (
              <MDBox key={g.ref} sx={{ minWidth: 260 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      checked={filtroGrupoClienteSelecionado(g.ref)}
                      onChange={() =>
                        toggleFiltroCampanha("refentidadegrupo", "INCLUIR", g.ref, g.nome || "")
                      }
                    />
                  }
                  label={
                    <span style={{ fontSize: 13 }}>
                      {g.nome || g.ref} <span style={{ color: "#9e9e9e" }}>({g.ref})</span>
                    </span>
                  }
                />
              </MDBox>
            ))}
          </MDBox>
        </AccordionDetails>
      </Accordion>

      <Accordion
        expanded={expandedFiltroCliente === "segmentos"}
        onChange={handleFiltroClienteAccordion("segmentos")}
        disableGutters
        sx={{
          backgroundColor: "#fff7f0",
          borderRadius: 2,
          "&:before": { display: "none" },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ fontSize: 18 }} />}
          sx={{
            minHeight: 32,
            px: 1.5,
            "& .MuiAccordionSummary-content": { margin: "4px 0" },
          }}
        >
          <MDTypography variant="button" sx={{ fontSize: 12 }}>
            Segmentos de clientes
          </MDTypography>
        </AccordionSummary>

        <AccordionDetails sx={{ pt: 0, pb: 1.5, px: 1.5 }}>
          <MDBox mb={1}>
            <MDButton
              size="small"
              color="info"
              disabled={loadingFiltrosCampanha}
              onClick={async () => {
                const camposSegmentos = [
                  "segmentopotencial",
                  "segmenton1",
                  "segmenton2",
                  "segmenton3",
                ];

                const filtrosSegmentosAtuais = filtrosCampanha.filter((f) =>
                  camposSegmentos.includes(String(f.campo || ""))
                );

                if (filtrosSegmentosAtuais.length > 0) {
                  await atualizarFiltrosCampanhaLote(
                    camposSegmentos,
                    camposSegmentos.map((campo) => ({
                      campo,
                      tipo: "NENHUM",
                      valor: "1",
                      obs: "Nenhum selecionado",
                    }))
                  );
                  return;
                }

                const novosFiltros = segmentosClientes.map((s) => ({
                  campo: s.campo,
                  tipo: "INCLUIR",
                  valor: s.valor,
                  obs: s.valor,
                }));

                await atualizarFiltrosCampanhaLote(camposSegmentos, novosFiltros);
              }}
            >
              {loadingFiltrosCampanha
                ? "A atualizar..."
                : filtrosCampanha.some((f) =>
                    ["segmentopotencial", "segmenton1", "segmenton2", "segmenton3"].includes(
                      String(f.campo || "")
                    )
                  )
                ? "Desselecionar todos"
                : "Selecionar todos"}
            </MDButton>
          </MDBox>

          {["segmentopotencial", "segmenton1", "segmenton2", "segmenton3"].map((campo) => (
            <MDBox key={campo} mb={1}>
              <MDTypography variant="caption" sx={{ fontWeight: 600 }}>
                {campo}
              </MDTypography>

              <MDBox display="flex" flexWrap="wrap" gap={1}>
                {segmentosClientes
                  .filter((s) => s.campo === campo)
                  .map((s) => (
                    <MDBox key={`${campo}-${s.valor}`} sx={{ minWidth: 220 }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            size="small"
                            checked={filtroExiste(campo, "INCLUIR", s.valor)}
                            onChange={() =>
                              toggleFiltroCampanha(campo, "INCLUIR", s.valor, s.valor)
                            }
                          />
                        }
                        label={<span style={{ fontSize: 13 }}>{s.valor}</span>}
                      />
                    </MDBox>
                  ))}
              </MDBox>
            </MDBox>
          ))}
        </AccordionDetails>
      </Accordion>

      <MDBox mt={2}>
        <MDTypography variant="button" sx={{ fontSize: 12, mb: 0.5, display: "block" }}>
          Clientes abrangidos
        </MDTypography>

        <Autocomplete
          size="small"
          options={clientesCombo}
          filterOptions={(x) => x}
          inputValue={clienteInput}
          disabled={filtroExiste("cliente", "TODOS", "1")}
          getOptionLabel={(option) => (option?.nome ? `${option.nome} (${option.ref})` : "")}
          value={null}
          onInputChange={(_, value, reason) => {
            if (reason === "input") {
              setClienteInput(value);
              carregarClientesCombo(value);
            }

            if (reason === "clear") {
              setClienteInput("");
            }
          }}
          onChange={async (_, value) => {
            if (!value?.ref) return;

            await adicionarFiltroCampanha("cliente", "INCLUIR", value.ref, value.nome || "");
            setClienteInput("");
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder={
                filtroExiste("cliente", "TODOS", "1") ? "Todos os clientes" : "Pesquisar cliente..."
              }
            />
          )}
        />

        <MDBox mt={1}>
          <FormControlLabel
            control={
              <Checkbox
                size="small"
                checked={filtroExiste("cliente", "TODOS", "1")}
                onChange={async () => {
                  const todos = filtrosCampanha.find(
                    (f) =>
                      String(f.campo || "") === "cliente" &&
                      String(f.tipo || "") === "TODOS" &&
                      String(f.valor || "") === "1"
                  );

                  if (todos) {
                    await atualizarFiltrosCampanhaLote(["cliente"], []);
                    return;
                  }

                  await atualizarFiltrosCampanhaLote(
                    ["cliente"],
                    [
                      {
                        campo: "cliente",
                        tipo: "TODOS",
                        valor: "1",
                        obs: "Todos",
                      },
                    ]
                  );
                }}
              />
            }
            label={<span style={{ fontSize: 13 }}>Todos os clientes</span>}
          />
        </MDBox>

        <MDBox mt={1}>
          {filtrosPorCampo("cliente")
            .filter((f) => String(f.tipo || "") === "INCLUIR")
            .map((f) => (
              <MDBox
                key={f.id}
                display="grid"
                gridTemplateColumns="1fr auto"
                gap={1}
                alignItems="center"
                py={0.5}
                sx={{ borderTop: "1px solid #e0e0e0" }}
              >
                <MDTypography variant="caption">
                  {f.obs || f.valor} <span style={{ color: "#9e9e9e" }}>({f.valor})</span>
                </MDTypography>

                <IconButton
                  size="small"
                  color="error"
                  onClick={() => removerFiltroCampanha(f)}
                  title="Remover cliente"
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </MDBox>
            ))}
        </MDBox>
      </MDBox>
    </MDBox>
  );
}
